<template>
    <button
        class="cursor-pointer bg-white/70 backdrop-blur-sm shadow rounded-lg p-2 flex justify-center items-center hover:bg-gray-100 size-10"
        @click="copyUrlToClipboard"
        title="Zkopírovat URL adresu"
    >
        <span class="esri-icon esri-icon-share2 text-lg!"></span>
    </button>
    <Teleport to="body">
        <div
            class="share-url-toast fixed bottom-10 left-1/2 -translate-x-1/2 bg-white/70 backdrop-blur-sm text-sm rounded-lg shadow py-2 px-4 pointer-events-none duration-300"
            :class="{
                'opacity-100 translate-y-0': toastVisible,
                'opacity-0 translate-y-full': !toastVisible,
            }"
        >
            URL adresa zkopírována!
        </div>
    </Teleport>
</template>

<script setup lang="ts">
import { ref } from "vue"

const toastVisible = ref(false)

function getPositionParams() {
    const view = window.app.view
    const camera = view.camera
    return `?lat=${camera.position.latitude}&lon=${camera.position.longitude}&z=${camera.position.z}&tilt=${camera.tilt}&heading=${camera.heading}`
}

function copyUrlToClipboard() {
    const url =
        window.location.origin + window.location.pathname + getPositionParams()
    navigator.clipboard
        .writeText(url)
        .then(() => {
            console.log("URL copied to clipboard:", url)
            toastVisible.value = true
            setTimeout(() => {
                toastVisible.value = false
            }, 2000)
        })
        .catch(err => {
            console.error("Failed to copy URL:", err)
        })
}
</script>

<style scoped></style>
